import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, firstValueFrom } from "rxjs";
import { Helper } from "src/app/core/helpers/helper";

@Injectable({
  providedIn: "root"
})
export class MapBoxService {
  constructor(private http: HttpClient, private helper: Helper) {}

  search(query: string, countryCode: string = "", isOnlyCitySuggestion: boolean = false): Observable<any> {
    let url: any = "";
    if (isOnlyCitySuggestion && countryCode) {
      url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=${this.helper.MapBoxAccessToken}&types=place&country=${countryCode}`;
    } else if (countryCode) {
      url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=${this.helper.MapBoxAccessToken}&country=${countryCode}`;
    } else {
      url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=${this.helper.MapBoxAccessToken}`;
    }
    return this.http.get(url);
  }

  reverseGeocode({ latitude, longitude }: { latitude: number; longitude: number }): any {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${this.helper.MapBoxAccessToken}`;
    return firstValueFrom(this.http.get(url));
  }

  async extractMapboxPlaceDetails(placeFeature: any): Promise<any> {
    const location = {
      lat: placeFeature.center?.[1],
      lng: placeFeature.center?.[0]
    };

    const addressComponents = [];

    // Convert context to Google-like address_components
    (placeFeature.context || []).forEach((contextItem: any) => {
      const [type] = contextItem.id.split(".");
      addressComponents.push({
        long_name: contextItem.text,
        short_name: contextItem.short_code?.toUpperCase() || contextItem.text,
        types: [type]
      });
    });

    // Add primary place
    if (placeFeature.text) {
      addressComponents.push({
        long_name: placeFeature.text,
        short_name: placeFeature.text,
        types: placeFeature.place_type || ["place"]
      });
    }

    return {
      displayName: placeFeature.text,
      formattedAddress: placeFeature.place_name,
      geometry: { location },
      address_components: addressComponents,
      types: placeFeature.place_type || [],
      placeId: placeFeature.id
    };
  }
}
